import { useMemo } from 'react';
import { OrderDetailsResponse } from '@zonofi/zono-money-store';
import { getCalculatedAmount } from '@zonofi/common/functions/format-amount';
import { SVGS } from '../../assets';

export const useOrderDetailsInfo = (orderDetailsData: OrderDetailsResponse) => {
  const orderRelatedInfo = useMemo(() => {
    if (!orderDetailsData) return [];

    return [
      {
        id: 0,
        icon: SVGS.OrderIconGray,
        title: 'Order ID',
        value: `#${orderDetailsData.refOrderNumber ?? 'N/A'} • ${
          orderDetailsData.skucount ?? 0
        } SKU’s • ${
          getCalculatedAmount(orderDetailsData.totalWithTax ?? 0) ?? 'N/A'
        }`,
      },
      {
        id: 1,
        icon: SVGS.UserIconGray,
        title: 'Ordered By',
        value: orderDetailsData?.createdByName || 'N/A',
      },
      ...(orderDetailsData?.tags?.length > 0
        ? [
            {
              id: 2,
              icon: SVGS.TagIconGray,
              title: 'Tags',
              value: orderDetailsData.tags,
            },
          ]
        : []),
    ];
  }, [orderDetailsData]);

  return {
    orderRelatedInfo,
  };
};
